import type { CategoryGridItem } from "@ui/components/core/CategoryGrid/CategoryGrid";

import PageSection from "@ui/components/composers/PageSection";
import { BlockTitle } from "@/app/_blocks/BlockTitle";
import { MusicSimilarCollectionsGrid } from "./MusicSimilarCollectionsGrid";

interface MusicSimilarCollectionsProps {
  title: string;
  items: CategoryGridItem[];
}

export function MusicSimilarCollections({ title, items }: MusicSimilarCollectionsProps) {
  if (items.length === 0) return null;

  return (
    <>
      <PageSection
        withGap={false}
        withSideLines
        withFilledLine
        topPadding='default'
        bottomPadding='small'
        horizontalPadding='default'
      >
        <BlockTitle title={title} layout='default' />
      </PageSection>
      <PageSection
        withGap={false}
        withSideLines
        withFilledLine
        withEdgeLines={false}
        topPadding='none'
        bottomPadding='none'
        horizontalPadding='none'
      >
        <MusicSimilarCollectionsGrid items={items} />
      </PageSection>
    </>
  );
}
